import memoize from 'lodash.memoize';
import { useEffect, useState } from 'react';
import req from 'utils/req';

const makeRequest = memoize((country: string) =>
  req(`${URL_API_HOST}/api/v2/location-areas/${country}`).get(),
);

const useCitiesByCountry = (country: string) => {
  const [cities, setCities] = useState([]);
  useEffect(() => {
    makeRequest(country).then((locationAreas) =>
      setCities(
        locationAreas.map((locationArea) => ({
          country: locationArea.country,
          area: locationArea.area,
          city: locationArea.area,
          image: locationArea.image
            ? `https://withlocals-com-res.cloudinary.com/image/upload/${locationArea.image}`
            : locationArea.image,
          nrOfExperiences: locationArea.experienceCount,
          nrOfHosts: locationArea.hostCount,
        })),
      ),
    );
  }, [country]);

  return cities;
};

export default useCitiesByCountry;
